<script>
    import { createEventDispatcher } from 'svelte';

    export let style;
    export let disabled;
    export let loading;
    export let hasBg = false

    const doc = document.documentElement;
    const dispatch = createEventDispatcher();

    const createRipple = (event) => {
        const button = event.currentTarget;
        const circle = document.createElement('span');
        const diameter = Math.max(button.clientWidth, button.clientHeight);
        const radius = diameter / 2;
        const scrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        const pos = button.getBoundingClientRect();
        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${event.clientX - (pos.left + scrollLeft) - radius}px`;
        circle.style.top = `${event.clientY - (pos.top + scrollTop) - radius}px`;
        circle.classList.add('ripple');

        const ripple = button.getElementsByClassName('ripple')[0];

        if (ripple) {
            ripple.remove();
        }

        button.appendChild(circle);
        dispatch('click', event);
    };
</script>

<div {style} {disabled}>
    <button on:click={createRipple} disabled={loading || disabled} class={`${hasBg? 'background' : ''}`} >
        <slot />
        <span class={`${loading ? "loader": ""}`}></span>
    </button>
</div>

<style>
    button {
        position: relative;
        overflow: hidden;
        padding: 0;
        border: none;
        border-radius: 2px;
        text-transform: uppercase;
        cursor: pointer;
        background-color: transparent;
        outline: none;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .background {
        background-color: #0e99d2;
    }

    .background:disabled {
        background-color: #7cbdd7;
    }

    .loader {
      width: 25px;
      height: 21px;
      border-radius: 50%;
      position: relative;
      animation: rotate 1s linear infinite;
      margin-right: 20px;
    }
    .loader::before {
      content: "";
      box-sizing: border-box;
      position: absolute;
      inset: 0px;
      border-radius: 50%;
      border: 2px solid #FFF;
      animation: prixClipFix 2s linear infinite ;
    }

    @keyframes rotate {
      100%   {transform: rotate(360deg)}
    }

    @keyframes prixClipFix {
        0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
        25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
        50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
        75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
        100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
    }
</style>
